import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { apiFetch } from "../api/api";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("pending"); // pending | success | error
  const [message, setMessage] = useState("Verifying your email…");

  useEffect(() => {
    async function run() {
      if (!token) {
        setStatus("error");
        setMessage("Missing verification token.");
        return;
      }
      try {
        const res = await apiFetch(`/verify-email?token=${encodeURIComponent(token)}`);
        setStatus("success");
        setMessage(res?.message || "Email verified.");
      } catch (err) {
        setStatus("error");
        const msg = err?.body?.error || err.message || "Verification failed.";
        setMessage(msg);
      }
    }
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div style={{ maxWidth: 560, margin: "40px auto", padding: "24px", background: "#fff", borderRadius: 8, boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
      <h1 style={{ marginTop: 0 }}>Email Verification</h1>
      <p style={{ color: status === "error" ? "#b00020" : "#111" }}>{message}</p>
      {status === "success" && (
        <div style={{ marginTop: 16 }}>
          <Link to="/login" style={{ color: "#1769aa", textDecoration: "none", fontWeight: 600 }}>Go to Login</Link>
        </div>
      )}
      {status === "error" && (
        <div style={{ marginTop: 16 }}>
          <p style={{ marginBottom: 8 }}>If you think this is a mistake, try the link in your email again or request a new one.</p>
          <Link to="/login" style={{ color: "#1769aa", textDecoration: "none", fontWeight: 600 }}>Back to Login</Link>
        </div>
      )}
    </div>
  );
}
